<template>
    <span> 
    </span>
    <v-sheet v-if="showGraphs" :class="xs?'card-dialogs-graph-wop':'card-dialogs-graph'" class="mb-4" color="bgtopology">
            
        <MultipleCharts 
        v-if="allResetData.allData.length > 0"
        :array-items="allResetData.allData"
        :array-names="allResetData.allName"
        :title="'Reset'"
        />
        <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
        </v-sheet>
    </v-sheet>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

/********************************
 *********** SERVICES ***********
 *******************************/
import { getClientStatusDataByIPS } from '@/services/Smartlink/Reset'

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t }  = useI18n();

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ********** COMPONENTS **********
 *******************************/
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import MultipleCharts from '../charts/MultipleCharts.vue';

const props = defineProps({
    finalIPS  : { type: Array<string>, required:true }
})

const params = {
    ips : props.finalIPS
}

const showGraphs = ref(true)
const allResetData = ref({
    allData : [],
    allName : []
})

async function getClientStatusByIP() {

    const allData = await getClientStatusDataByIPS(params)

    if( allData.status === 400 ){
        showGraphs.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showGraphs.value = allData.showGraphs
        allResetData.value = allData.data
    }
}

onMounted(() => {
    getClientStatusByIP();
})

</script>